export type StorageType = {
	type: string;
	pve_name: string;
	product_id: number;
	min_storage: number;
	max_storage: number;
	max_storage_superuser: number;
	step: number;
	bytes_format: string;
};

export type ExistingStorageType = {
	type: string;
	size: number;
	unit: string;
};

/**
 * This function fetches the storage configuration based on given 'storage_type' as string.
 * When you need the min and max allowed values for a certain storage type, you'll have to use this function and give the correct storage type name.
 * Make sure it corresponds to the 'type' value.
 */

export default function fetchStorageType({
	storage_list,
	storage_type_key,
}: {
	storage_list: Array<StorageType> | Array<ExistingStorageType>;
	storage_type_key: "default" | "bulk" | "performance";
}): StorageType | ExistingStorageType | null {
	if (!storage_list) {
		return null;
	}
	const length = storage_list.length;

	for (let i = 0; i < length; i++) {
		if (storage_list[i].type === storage_type_key) {
			return storage_list[i];
		}
	}
	return;
}

export function fetchStorageTypeV2({
	storage_list,
	storage_type_key,
	get_boot_disk = false,
}: {
	storage_list: Array;
	storage_type_key: "default" | "bulk" | "performance";
	get_boot_disk: boolean;
}): StorageType | ExistingStorageType | null {
	if (!storage_list) {
		return null;
	}
	const length = storage_list.length;

	for (let i = 0; i < length; i++) {
		if (storage_list[i].portal_name === storage_type_key) {
			if (get_boot_disk === true && storage_list[i].bootdisk === false) {
				continue;
			}
			return storage_list[i];
		}
	}
	return;
}

export const determMaxConfigurationValue = (
	superuser: boolean,
	superuserValue: number | undefined,
	userValue: number | undefined,
	defaultValue: number | undefined,
) => {
	const value = superuser ? superuserValue : userValue;
	return Math.max(Number(value || 0), Number(defaultValue || 0));
};
